import React, {useEffect} from 'react';
import './CreditFreezeInfo.scss';
import {closeTier3ModalEvent} from '../../../utils/tier-3-modal-close/PrequalCloseEvent';
import FreezeIcon from '../../../assets/icons/snowflake-dark-blue.svg';
import FreezeIconWC from '../../../assets/icons/snowflake-light-blue.svg';
import RefreshIcon from '../../../assets/icons/refresh.svg';
import {getQueryElement} from '../../../utils/queryElement';
import {tagCreditFreezePrequalifiedResultView} from '../../../Services/TaggingService/TaggingService';
import {trackEvents} from '../../../Services/OptimizelyService/OptimizelyService';

function CreditFreezeInfo({result, customerData, dispatch}) {
  function closeEvent() {
    closeTier3ModalEvent({}, dispatch, customerData);
  }

  useEffect(() => {
    if (!customerData.isDealerHostApplication.value) {
      getQueryElement(customerData).getElementById('prequal--web--app').scrollIntoView();
    }
    const {offerId} = result;
    tagCreditFreezePrequalifiedResultView(offerId, customerData);
    if (customerData.prequalSource.value === 'web' && customerData?.recaptchaOptimizelyData?.isEnabled) {
      trackEvents('Decision Page View', customerData);
    }
  }, []);

  return (
    <>
      {customerData.isDealerHostApplication.value ? (
        <div
          id='prequal--web--credit-freeze-container'
          data-testid='creditFreezeContainer'
          className='prequal--web--credit-freeze-container prequal--wc--credit-freeze-container'
        >
          <div className='prequal--web--credit-freeze-content prequal--wc--credit-freeze-content'>
            {getContent(true)}
            <div className='prequal--wc--offer-close'>
              <button
                type='button'
                className='prequal--web--submit-prequalification-button prequal--wc--offer-close-button'
                onClick={closeEvent}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div
          id='prequal--web--credit-freeze-container'
          data-testid='creditFreezeContainer'
          className='prequal--web--credit-freeze-container'
        >
          <div className='prequal--web--credit-freeze-content'>{getContent(false)}</div>
        </div>
      )}
    </>
  );
}

function getContent(isDealerHost) {
  return (
    <>
      <div className='prequal--web--credit-freeze-content-block'>
        <img src={isDealerHost ? FreezeIconWC : FreezeIcon} alt='Credit freeze icon' />
        <div className='prequal--web--credit-freeze-content-text'>
          <h1>Credit Freeze Detected</h1>
          <p>We couldn’t reach a decision about your prequalification because you may have a credit freeze on your account.</p>
        </div>
      </div>
      <div className='prequal--web--credit-freeze-text-content-container'>
        <h3>What&apos;s a Credit Freeze?</h3>
        <p>
          A credit freeze locks the data at the consumer reporting agency until the individual gives permission for the release of the data.
        </p>
        <h3 className='prequal--web--credit-freeze-title'>What Can You Do?</h3>
        <p>
          The quickest and easiest way to unfreeze your credit report is to contact the credit bureau (or bureaus) you used to freeze your
          credit either online or by phone.
        </p>
      </div>
      <div className='prequal--web--credit-freeze-footer'>
        <a>
          <img src={RefreshIcon} alt='reload link' />
        </a>
        <p>Once you’ve removed your credit freeze feel free to prequalify again!</p>
      </div>
    </>
  );
}

export default CreditFreezeInfo;
